import { randomString } from '@/utils/tools';

/**
 * 生成唯一的事件 ID
 * 格式: {timestamp}-{randomString}
 * @returns 唯一的事件 ID
 */
export function generateEventId(): string {
  const timestamp = Date.now();
  const random = randomString(8); // 生成 8 位随机字符串
  return `${timestamp}-${random}`;
}
